import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import TextInput from '../form/TextInput'; //eslint-disable-line import/no-named-as-default
import * as initActions from '../../actions/initActions';
import * as trackingDataActions from '../../actions/trackingDataActions';
import * as dialogPopupActions from '../../actions/dialogPopupActions';
import * as userDataActions from '../../actions/userDataActions';
import * as objectConstants from '../../constants/objectConstants';
import * as appHelper from '../../helpers/appHelper';

class ExitPrompt extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            welcome_back_label: appHelper.getLocaleString("welcome_back_label"),
            guest_label: appHelper.getLocaleString("guest_label"),
            resume_prompt: appHelper.getLocaleString("resume_prompt"),
            resume_continue_label: appHelper.getLocaleString("resume_continue_label"),
            review_from_beginning_label: appHelper.getLocaleString("review_from_beginning_label"),
            clear_and_restart_label: appHelper.getLocaleString("clear_and_restart_label"),

        };
        this.resumeContinue = this.resumeContinue.bind(this);
        this.resumeReview = this.resumeReview.bind(this);
        this.clearResults = this.clearResults.bind(this);

    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                welcome_back_label: appHelper.getLocaleString("welcome_back_label"),
                guest_label: appHelper.getLocaleString("guest_label"),
                resume_prompt: appHelper.getLocaleString("resume_prompt"),
                resume_continue_label: appHelper.getLocaleString("resume_continue_label"),
                review_from_beginning_label: appHelper.getLocaleString("review_from_beginning_label"),
                clear_and_restart_label: appHelper.getLocaleString("clear_and_restart_label"),
            });
        }
    }

    componentDidUpdate() {

    }

    resumeContinue(){
        this.props.actions.removeDialog();
        let lesson_location = this.props.trackingData.lesson_location;
        let bookmark = appHelper.getBiteByScreenId(lesson_location);
        this.props.actions.setLessonLocation(lesson_location);
        this.context.router.push(`/${bookmark}`);
    }

    resumeReview(){
        this.props.actions.removeDialog();
        let lesson_location = this.props.contentData.experience.bites[0].screens[0].screen_id;
        let bookmark = appHelper.getBiteByScreenId(lesson_location);
        this.props.actions.setLessonLocation(lesson_location);
        this.context.router.push(`/${bookmark}`);
    }

    clearResults(){
        this.props.actions.setInitialUserData(this.props.contentData.experience).then((userData) => {
            this.props.actions.setSuspendData(userData).then((userData) => {
                this.resumeReview();
            }).catch(error => {
            });
        }).catch(error => {
        });
    }

    render() {
        return (
            <div className="init-prompt-content text-center">
                <p>{this.state.welcome_back_label}
                    {this.props.trackingData.first_name.length > 0
                        ?
                        <span> {this.props.trackingData.first_name.includes('Guest') || (!appHelper.isDefined(this.props.contentData.experience.learner_name_display_type) || (appHelper.isDefined(this.props.contentData.experience.learner_name_display_type) && this.props.contentData.experience.learner_name_display_type !== objectConstants.YOU)) ? "" : `${this.props.trackingData.first_name}.`}</span>
                        :
                        null
                    }
                    </p>
                <p>{this.state.resume_prompt}</p>
                <br/>
                {
                    this.props.contentData.experience.include_continue_from_last_screen
                    ?
                        <div className="object-container">
                            <button className="btn btn-lg guroo-btn" onClick={this.resumeContinue} dangerouslySetInnerHTML={{__html: this.state.resume_continue_label}}/>
                        </div>
                    :
                        null
                }

                {
                    this.props.contentData.experience.include_review_from_beginning
                        ?
                        <div className="object-container">
                            <button className="btn btn-lg guroo-btn" onClick={this.resumeReview} dangerouslySetInnerHTML={{__html: this.state.review_from_beginning_label}}/>
                        </div>
                        :
                        null
                }
                {
                    this.props.contentData.experience.include_clear_history_and_start_over
                        ?
                        <div className="object-container">
                            <button className="btn btn-lg guroo-btn" onClick={this.clearResults} dangerouslySetInnerHTML={{__html: this.state.clear_and_restart_label}}/>
                        </div>
                        :
                        null
                }
            </div>
        );
    }
}

ExitPrompt.propTypes = {
    initData: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

ExitPrompt.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        initData: state.initData,
        contentData: state.contentData,
        trackingData: state.trackingData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, initActions, trackingDataActions, dialogPopupActions, userDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ExitPrompt);



/** WEBPACK FOOTER **
 ** ./src/components/initialisation/ResumePrompt.js
 **/